<template>
  <div class="layout">
    <Layout>
      <Header>
        <Menu mode="horizontal" theme="" active-name="">
          <div class="layout-logo">
            <img src="/static/lx-logo.png" height="40" alt="Logo" align="middle">
          </div>
          <div class="layout-nav">
            <MenuItem name="home" to="/">
              <Icon type="md-home" size="18"/>
              首页
            </MenuItem>
            <MenuItem v-if="this.role === config.ROLES.ADMIN || this.role === config.ROLES.USER" name="customer" to="/customer">
              <Icon type="md-contacts" size="18"/>
              客户
            </MenuItem>
            <MenuItem v-if="this.role === config.ROLES.ADMIN" name="account" to="/account">
              <Icon type="md-grid" size="18"/>
              账号
            </MenuItem>

            <MenuItem v-if="this.role === config.ROLES.ADMIN" name="user" to="/user">
              <Icon type="md-person" size="18"/>
              用户
            </MenuItem>

            <MenuItem name="extension" to="/extension">
              <Icon type="md-cube" size="18"/>
              扩展
            </MenuItem>

            <MenuItem v-if="!nickname" name="login" to="/login">
              <Icon type="md-log-in" size="18"/>
              登录
            </MenuItem>

            <Submenu v-else name="profile">
              <template #title>
                <Icon type="md-happy" size="18"/>
                {{ nickname }}
              </template>
              <!--                <MenuItem name="profile-1">修改信息</MenuItem>-->
              <MenuItem name="profile-2" @click="handleLogout">退出登录</MenuItem>
            </Submenu>
          </div>
        </Menu>
      </Header>
      <Content :style="{padding: '20px 50px'}">
        <Card>
          <div style="min-height: 200px; min-width: 1200px">
            <router-view/>
          </div>
        </Card>
      </Content>
      <Footer class="layout-footer-center">2011-2025 &copy; mlkj.cc</Footer>
    </Layout>
  </div>
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
  min-width: 1440px;
}

.layout {
  position: relative;
  overflow: hidden;
}

.layout-logo {
  float: left;
}

.layout-nav {
  margin: 0 auto;
  margin-right: 20px;
  float: right;
}

.layout-footer-center {
  text-align: center;
}

.layout .ivu-layout-header {
  background: #191a23;
}

.layout a.ivu-menu-item {
  color: #fff;
}

.layout-topMiddleBottom .ivu-menu-light {
  background: none;
  color: #fff
}

.layout .ivu-menu-submenu-title {
  color: #fff;
}
</style>
<script>
import config from "./config";

export default {
  data() {
    return {
      nickname: '',
      role: 0,
      config: config
    }
  },
  mounted() {
    console.log('mounted')
    this.nickname = localStorage.getItem(config.STORAGE_KEYS.USER_NICKNAME);
    this.role = parseInt(localStorage.getItem(config.STORAGE_KEYS.USER_ROLE));
  },
  methods: {
    handleLogout() {
      console.log('logout')
      localStorage.removeItem(config.STORAGE_KEYS.USER_USERNAME);
      localStorage.removeItem(config.STORAGE_KEYS.USER_NICKNAME);
      localStorage.removeItem(config.STORAGE_KEYS.USER_ROLE);
      localStorage.removeItem(config.STORAGE_KEYS.ACCESS_TOKEN);
      localStorage.removeItem(config.STORAGE_KEYS.REFRESH_TOKEN);
      this.$Message.info('已退出登录');
      setTimeout(() => {
        window.location.href = '/login';
      }, 1000)
    }
  }
}
</script>
